// extracted by mini-css-extract-plugin
export default {"overlayBackground":"CommonOverlayBackground_overlayBackground__tpZK4","isMain":"CommonOverlayBackground_isMain__-TfL3"};